import React from "react";
import { Table, TableBody, TableCell, TableRow, Text } from "@jsq/ds/core";
import { tableRow } from "./styles_vanilla.css";

export type OtherPaymentPrefDisplayProps = {
  /**
   * GP-authored, display-only label snapshotted at pref creation. Callers should pass
   * `nonUsPaymentPref.otherPaymentPrefLabel` once union dispatch is wired in (FF-8000).
   */
  label: string;
  /**
   * Free-form instructions snapshotted at pref creation. Callers should pass
   * `nonUsPaymentPref.nonUsPaymentPrefInstructions` once union dispatch is wired in
   * (FF-8000) — the field stays on the `nonUs*` name for backward compatibility even
   * though it now backs Other prefs too.
   */
  instructions: string;
};

export const OtherPaymentPrefDisplay: React.FC<OtherPaymentPrefDisplayProps> = ({
  label,
  instructions,
}: OtherPaymentPrefDisplayProps) => {
  return (
    <Table condensed data-testid="OtherPaymentPrefDisplayTable">
      <TableBody>
        <TableRow className={tableRow} alignment="top">
          <TableCell>
            <Text variant="regular-md">{label}</Text>
          </TableCell>
        </TableRow>
        <TableRow className={tableRow} alignment="top">
          <TableCell>
            {/* The LP's textarea input is stored with literal `\n`s and only becomes
                `<br/>` server-side at IQ-render time (panels.py's `_get_non_us()`);
                `pre-line` reproduces the same line breaks here without injecting HTML. */}
            <Text
              variant="regular-md"
              data-testid="OtherPaymentPrefDisplayInstructions"
              style={{ whiteSpace: "pre-line" }}
            >
              {instructions}
            </Text>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
